import { SupportAnnounce8Component } from "./current/SupportAnnounce8Component";

export function EntrepreneurAnnounce8FormComponent() {
    return (
        <SupportAnnounce8Component />
    );
}
